<section class="callbackJournalPage">
  <header class="pageHeader">
    <div>
      <div class="eyebrow">B2C</div>
      <h1>Журнал перезвонов</h1>
      <p>Заявки клиентов с формы обратного звонка.</p>
    </div>

    <div class="toolbar">
      <mat-button-toggle-group
        class="statusToggle"
        [value]="statusFilter"
        (change)="setStatusFilter($event.value)"
      >
        <mat-button-toggle *ngFor="let option of statusOptions" [value]="option.value">
          {{ option.label }}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <button mat-stroked-button color="primary" type="button" (click)="load()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Обновить
      </button>
    </div>
  </header>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="summaryStrip" *ngIf="response">
    <div>
      <strong>{{ totalLabel }}</strong>
      <span>Показано: {{ callbacks.length }}</span>
    </div>
    <div>
      <strong>{{ newInList }}</strong>
      <span>В списке ждут звонка</span>
    </div>
    <div>
      <strong>{{ doneInList }}</strong>
      <span>В списке закрыто</span>
    </div>
  </section>

  <div class="errorState" *ngIf="error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error }}</span>
  </div>

  <section class="tableShell" *ngIf="!error">
    <table
      mat-table
      [dataSource]="callbacks"
      [trackBy]="trackByRequest"
      *ngIf="callbacks.length; else emptyState"
    >
      <ng-container matColumnDef="request">
        <th mat-header-cell *matHeaderCellDef>Заявка</th>
        <td mat-cell *matCellDef="let request">
          <div class="requestCell">
            <span class="requestBadge">CALL</span>
            <strong>#{{ request.id }}</strong>
            <small>{{ getRequestDateLabel(request) }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef>Клиент и телефон</th>
        <td mat-cell *matCellDef="let request">
          <a
            *ngIf="getClientLink(request) as link; else plainClient"
            class="clientLink"
            [routerLink]="link"
          >
            <strong>{{ getClientLabel(request) }}</strong>
            <span>{{ getClientMeta(request) }}</span>
          </a>
          <ng-template #plainClient>
            <div class="clientLink clientLink--plain">
              <strong>{{ getClientLabel(request) }}</strong>
              <span>{{ getClientMeta(request) }}</span>
            </div>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="page">
        <th mat-header-cell *matHeaderCellDef>Страница</th>
        <td mat-cell *matCellDef="let request">
          <a
            *ngIf="getPageUrl(request); else noPage"
            class="pageLink"
            [href]="getPageUrl(request)"
            target="_blank"
            rel="noopener noreferrer"
            [title]="getPageUrl(request)"
          >
            {{ getPageLabel(request) }}
          </a>
          <ng-template #noPage>
            <span class="mutedText">-</span>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Статус</th>
        <td mat-cell *matCellDef="let request">
          <span [class]="getStatusClass(request)">{{ getStatusLabel(request) }}</span>
          <div>{{ getOutcomeLabel(request) }}</div>
          <div class="mutedText" *ngIf="request.last_attempt_at">Попытка: {{ request.last_attempt_at | date:'dd.MM HH:mm' }}</div>
          <div class="mutedText" *ngIf="request.outcome_note">{{ request.outcome_note }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="closed">
        <th mat-header-cell *matHeaderCellDef>Закрытие</th>
        <td mat-cell *matCellDef="let request">
          <div class="closedCell">
            <strong>{{ getClosedLabel(request) }}</strong>
            <span *ngIf="getClosedMeta(request)">{{ getClosedMeta(request) }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let request">
          <div class="actionsCell">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="callButton"
              [disabled]="!canClickToCall(request) || callingRequestId !== null"
              (click)="clickToCall(request)"
            >
              <mat-spinner *ngIf="callingRequestId === request.id" diameter="18"></mat-spinner>
              <mat-icon *ngIf="callingRequestId !== request.id">phone</mat-icon>
              Позвонить
            </button>

            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="doneButton"
              [disabled]="request.status !== 'NEW' || completingRequestId !== null"
              (click)="complete(request)"
            >
              <mat-spinner *ngIf="completingRequestId === request.id" diameter="18"></mat-spinner>
              <mat-icon *ngIf="completingRequestId !== request.id">done</mat-icon>
              Результат
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <ng-template #emptyState>
      <div class="emptyState" *ngIf="!loading">
        <mat-icon>phone_callback</mat-icon>
        <div>
          <strong>Заявок нет</strong>
          <span>Для выбранного фильтра заявок на перезвон не найдено.</span>
        </div>
      </div>
    </ng-template>
  </section>
</section>
